import Icon from '../components/Icon.vue'

Icon.register({
  'book-open': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M542.2 32.1c18.4-1 33.8 13 33.8 30.7v337.8c0 16.2-13.1 29.8-30 30.7-49.5 2.6-149.5 12.1-218.7 46.9-10.6 5.4-23.3-1.9-23.3-13.5v-363.9c0-5.3 2.6-10.3 7.3-13.2 67.2-41.2 176.2-52.5 231-55.6zM264.7 87.6c4.6 2.9 7.3 7.7 7.3 13v364.1c0 11.5-12.6 18.8-23.2 13.5-69.2-34.8-169.3-44.3-218.8-47-16.9-0.9-30-14.4-30-30.7v-337.9c0-17.7 15.4-31.7 33.8-30.7 54.8 3.1 163.7 14.4 230.9 55.6z'
      }
    ]
  }
})
